import React from "react";
import withStyles from "react-jss";
import { Input } from "../../FormComponents";
import Button from "ComponentsUI/Button";
import AlertWrapper from "ComponentsUI/AlertWrapper";

const styles = (theme) => ({
	root: {
		position: "relative",
		display: "flex",
		alignItems: "center",
	},
	text: {
		fontSize: "16px",
		fontFamily: theme.fonts.medium,
		textAlign: "center",
		color: "#8e87a3",
	},
	upper: {
		display: "flex",
	},
	slot: {
		width: "280px",
		marginRight: "20px",
	},
	headerWrapper: {
		marginBottom: "17px",
	},
	buttonWrapper: {
		width: "280px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			flexWrap: "wrap",
		},
		upper: {
			marginBottom: "15px",
		},
		buttonWrapper: {
			width: "580px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			flexWrap: "wrap",
		},
		upper: {
			flexWrap: "wrap",
			marginBottom: "16px",
			width: "100%",
		},
		slot: {
			marginRight: 0,
			width: "100%",
			marginBottom: "16px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		buttonWrapper: {
			width: "100%",
		},
	},
});

class PhoneForm extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		let text = this.props.text;
		let data = this.props.data;
		if (!data.wasSended) {
			return (
				<div className={classes.root}>
					<div className={classes.upper}>
						<div className={classes.slot}>
							<Input
								value={data.name}
								error={data.error.name}
								onChange={(e) => this.props.changeData("name", e.target.value)}
								placeholder={`${text.orderName}*`}
							/>
						</div>
						<div className={classes.slot}>
							<Input
								error={data.error.phone}
								isPhone={true}
								changeCallback={(value) => this.props.changeData("phone", value)}
								placeholder={`${text.orderPhone}*`}
							/>
						</div>
					</div>
					<div className={classes.buttonWrapper}>
						<AlertWrapper error={data.globalError && text.COMMON_ERROR} center={true}>
							<Button
								onClick={() => this.props.onSubmit()}
								fullWidth={true}
								noPaddings={true}
								size="middle"
								status="purple"
							>
								{text.SEND}
							</Button>
						</AlertWrapper>
					</div>
				</div>
			);
		}

		return (
			<div className={classes.root}>
				<div className={classes.text}>{text.CONN_REQUEST_HINT_3_1}</div>
			</div>
		);
	}
}

export default withStyles(styles)(PhoneForm);
